<template>
  <div>
    <main role="main">
      <core-view />
    </main>
    <core-footer />
  </div>
</template>

<script>
export default {
  components: {
    CoreAppBar: () => import('@/components/core/guest/AppBar'),
    CoreView: () => import('@/components/core/guest/View'),
    CoreFooter: () => import('@/components/core/guest/Footer'),
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    source: String,
  },
  data: () => ({
    app_logo: process.env.appLogo,
    drawer: null,
  }),
  head: {
    bodyAttrs: {
      class: 'hold-transition layout-top-nav',
    },
  },
}
</script>

<style scoped>
/* Modern Footer Styles */
.footer-modern {
  position: relative;
  background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
  color: #e2e8f0;
  padding: 60px 0 30px;
  overflow: hidden;
}

.footer-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.05;
  z-index: 0;
}

.footer-decoration {
  position: absolute;
  top: -100px;
  right: -100px;
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  filter: blur(80px);
}

.footer-container {
  position: relative;
  z-index: 1;
}

.footer-col {
  margin-bottom: 30px;
}

.footer-card {
  height: 100%;
  padding: 20px;
}

/* Footer Logo */
.footer-logo {
  margin-bottom: 20px;
}

.footer-logo img {
  width: 180px;
  height: auto;
  filter: brightness(0) invert(1);
  transition: transform 0.3s ease;
}

.footer-logo img:hover {
  transform: scale(1.05);
}

.footer-description {
  font-size: 0.9rem;
  line-height: 1.7;
  color: #cbd5e0;
  margin: 0;
}

/* Footer Title */
.footer-title {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 15px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.3);
}

.footer-title i {
  color: #667eea;
  font-size: 1.2rem;
}

/* Footer Links */
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.contact-item i {
  color: #667eea;
  font-size: 1.1rem;
  margin-top: 3px;
  flex-shrink: 0;
}

.contact-link i {
  color: #667eea;
  font-size: 1.1rem;
  width: 20px;
  text-align: center;
}

.footer-links a {
  color: #cbd5e0;
  text-decoration: none;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  transition: all 0.3s ease;
  border-radius: 5px;
  padding-left: 5px;
}

.footer-links a:hover {
  color: #667eea;
  transform: translateX(5px);
  padding-left: 10px;
}

.footer-links a i.fa-chevron-right {
  font-size: 0.7rem;
  color: #667eea;
  transition: transform 0.3s ease;
}

.footer-links a:hover i.fa-chevron-right {
  transform: translateX(3px);
}

.footer-links a i:not(.fa-chevron-right) {
  width: 20px;
  text-align: center;
  color: #667eea;
}

/* Footer Contact */
.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-contact li {
  margin-bottom: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  color: #cbd5e0;
}

.contact-text {
  font-size: 0.95rem;
  line-height: 1.6;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #cbd5e0;
  text-decoration: none;
  font-size: 0.95rem;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: rgba(102, 126, 234, 0.1);
}

.contact-link:hover {
  color: #fff;
  background: rgba(102, 126, 234, 0.2);
  transform: translateX(5px);
}

.contact-link span {
  flex: 1;
}

/* Responsive Design */
@media screen and (max-width: 991px) {
  .footer-modern {
    padding: 50px 0 25px;
    margin-top: 60px;
  }

  .footer-card {
    padding: 15px;
    margin-bottom: 30px;
  }

  .footer-title {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 767px) {
  .footer-modern {
    padding: 40px 0 20px;
    margin-top: 40px;
  }

  .footer-logo img {
    width: 150px;
  }

  .footer-title {
    font-size: 1.1rem;
    margin-bottom: 20px;
  }

  .footer-description {
    font-size: 0.85rem;
  }

  .footer-links a,
  .contact-link {
    font-size: 0.9rem;
  }
}

@media screen and (max-width: 575px) {
  .footer-modern {
    padding: 30px 0 15px;
  }

  .footer-card {
    padding: 10px;
  }

  .footer-title {
    font-size: 1rem;
  }
}
</style>
